const t = "styles-module__tooltipContainer___JBJT5", o = "styles-module__tooltipIcon___PA4co", e = "styles-module__questionTooltip___og2Li", i = "styles-module__title___4VG8U", s = "styles-module__description___tKFev", _ = {
  tooltipContainer: t,
  tooltipIcon: o,
  questionTooltip: e,
  title: i,
  description: s
};
export {
  _ as default,
  s as description,
  e as questionTooltip,
  i as title,
  t as tooltipContainer,
  o as tooltipIcon
};
